import React, { useState, useEffect } from 'react';
import apiService from '../services/api';
import './Testimonials.css';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getFacebookEmbedUrl = (url) => {
    const videoId = url.match(/v=(\d+)/)?.[1];
    return videoId
      ? `https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fwatch%2F%3Fv%3D${videoId}&show_text=false&width=560&t=0`
      : null;
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      setLoading(true);
      const response = await apiService.getTestimonials();
      setTestimonials(response);
    } catch (err) {
      setError('Failed to load testimonials');
      console.error('Error fetching testimonials:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className='testimonials'>
        <div className='testimonials-container'>
          <div className='responsive-loading'>
            <div className='responsive-spinner' />
            <p>Loading Testimonials...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='testimonials'>
        <div className='testimonials-container'>
          <div className='error-message'>
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='testimonials'>
      <div className='testimonials-container'>
        <div className='testimonials-header'>
          <h1>Student Success Stories</h1>
          <p>Hear from our students who achieved their dreams</p>
        </div>

        <div className='testimonials-grid'>
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className='testimonial-card'
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {testimonial.type === 'video' && testimonial.video_url ? (
                <div className='testimonial-video'>
                  {testimonial.video_url.includes('facebook.com') ? (
                    <iframe
                      src={getFacebookEmbedUrl(testimonial.video_url)}
                      width='100%'
                      height='200'
                      style={{ border: 'none', overflow: 'hidden' }}
                      scrolling='no'
                      frameBorder='0'
                      allowFullScreen
                      allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'
                    ></iframe>
                  ) : (
                    <iframe
                      src={testimonial.video_url}
                      width='100%'
                      height='200'
                      frameBorder='0'
                      allowFullScreen
                    ></iframe>
                  )}
                </div>
              ) : (
                <>
                  <div className='quote-icon'>
                    <i className='fas fa-quote-left'></i>
                  </div>

                  <div className='testimonial-content'>
                    <p>"{testimonial.content || testimonial.message}"</p>
                  </div>
                </>
              )}

              <div className='testimonial-author'>
                {/*                 <div className="author-avatar">
                  <span>{testimonial.name ? testimonial.name.charAt(0) : ''}</span>
                </div> */}
                <div className='author-info'>
                  <h4>{testimonial.name || ''}</h4>
                  <span>{testimonial.university || testimonial.course || ''}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
